import {
    Drawer,
    
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Input,Button
  } from '@chakra-ui/react'
  import { useNavigate } from 'react-router-dom'
  import React from 'react'
  import { useDisclosure } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
 export function DrawerExample() {
    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = React.useRef()
    const handelclick=()=>{
        let token=localStorage.getItem("token")
        if(token){
         navigate("/fleshcard")
        }else{
         alert("Please Login 😒")
        }
     }
    return (
      <>
        <Button ref={btnRef} colorScheme='teal' onClick={onOpen}>
          Open
        </Button>
        <Drawer
          isOpen={isOpen}
          placement='right'
          onClose={onClose}
          finalFocusRef={btnRef}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Create your account</DrawerHeader>
  
            <DrawerBody>
              <Input placeholder='Study sets, texbooks, question' />
            <br />
            <br />
            
            <Button onClick={handelclick}>Create</Button>
           
            <br />
            <br />
          <Link to="/login">
              <button style={{backgroundColor:"grey",padding:"8px 15px 8px 15px",borderRadius:"10px"}} >Login</button>
              </Link>
              <br />
            <br />
            <Link to="/signup">
              <button style={{backgroundColor:"#ffcd1f",padding:"8px 15px 8px 15px",borderRadius:"10px"}}>Sign Up</button>
           
              </Link>
             
            </DrawerBody>
  
            
          </DrawerContent>
        </Drawer>
      </>
    )
  }